export const EMPTY_COUPON_PAGE_CONSTANTS = {
    BACKGROUND_IMAGE: "portal/m/gifting-cart/coupon-listing-gradient-bg.png",
    IMAGE: {
        CLOUDINARY_ID: "portal/static-assets/images/gifting-cart/No_coupons_v2.png",
        WIDTH: "240px",
        HEIGHT: "240px",
        ALT: "No Coupons Available",
    },
    TEXT: {
        HEADING: "No coupons available",
        DESCRIPTION: "You don’t have any active coupons for this order.",
        BUTTON_TEXT: "Got it!",
    },
};
